import { Component } from "@angular/core";

@Component({
    selector: "crew-dashboard",
    template: require('./dashboard.component.html')
})
export class DashboardComponent {   
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/dashboard/dashboard.component.ts